import apiClient from "./api";
const PARAMETROSESTUDIO_API_BASE_URL = "/parametrosEstudio";
class ParametrosEstudioService {
    
async getParametrosPorEstudio(estudioId) {
    try {
      const response = await apiClient.get(`${PARAMETROSESTUDIO_API_BASE_URL}/estudio/${estudioId}`,);
      return response.data.parametros;
    } catch (error) {
      console.error(error);
    }
  }
}
export default new ParametrosEstudioService();